<template>
    <div class="mt-4 unselectable">

        <b-container>
            <b-row align-h="center">
                <b-col class="mt-0 col-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="mt-5"></div>
                        <b-alert show dismissible variant="info"
                            class="small mt-0">
                          <div>{{$t('Show gender specific formulations?')}}</div>
                          <div>{{$t('Log in to access gender app')}}</div>
                            <div>{{$t('(or click maybe later)')}}</div>
                        </b-alert>

                        <b-alert show dismissible variant="success"
                            class="small mt-0">
                          {{$t('Free forever')}}
                        </b-alert>
                    <b-card
                    >
<!--                        <b-form @submit.prevent="submit">-->
<!--                            <b-form-group-->
<!--                                    :label="$t('Username:')"-->
<!--                                    id="usernameLabel"-->
<!--                                    label-for="username"-->
<!--                            >-->
<!--                                <b-form-input-->
<!--                                        :placeholder="$t('Enter username')"-->
<!--                                        id="username"-->
<!--                                        type="text"-->
<!--                                        v-model="username"-->
<!--                                ></b-form-input>-->
<!--                            </b-form-group>-->

<!--                            <b-form-group-->
<!--                                    :label="$t('Password:')"-->
<!--                                    id="passwordLabel"-->
<!--                                    label-for="password"-->
<!--                            >-->
<!--                                <b-form-input-->
<!--                                        :placeholder="$t('Enter password here')"-->
<!--                                        id="password"-->
<!--                                        type="password"-->
<!--                                        v-model="password"-->
<!--                                ></b-form-input>-->
<!--                            </b-form-group>-->
                            <form @submit.prevent="submit">
                              <label for="name">{{ $t('Username:') }}</label><br>
                              <input class="w-100"
                                     type="text" id="name" name="name" v-model="username"><br>
                              <label class="mt-2" for="password">{{ $t('Password:') }}</label><br>
                              <input class="w-100" type="password" id="password" name="password" v-model="password">
                            <div v-if="error">
                                <b-alert show="" variant="danger">
                                    {{error}}
                                </b-alert>
                            </div>
                            <b-form-checkbox
                              class="small mt-2"
                              id="checkbox-1"
                              name="checkbox-1"
                              unchecked-value="false"
                              v-model="pp_accept"
                              value="true"
                            >
                              {{$t('I accept the')}}
                                              <a href="https://genderapp.org/add-in-privacy-policy" target="_blank">{{$t('Privacy Policy')}}</a>
                            </b-form-checkbox>
                          <b-button type="submit"  class="btn btn-success btn-block m-2" >{{$t('Login')}}</b-button>
                          <b-button type="button"  class="btn btn-warning btn-block m-2" @click="skipLogin()" >{{$t('Skip Login')}}</b-button>
                      </form>
                    </b-card>
                  <b-card class="mt-1">
                    <b-button type="button" class="btn btn-info btn-block m-2" @click="openRegister()">{{$t('Register')}}</b-button>
                    <b-button type="button" class="btn btn-dark btn-block m-2" @click="openPWReset()">{{$t('Forgot password?')}}</b-button>
                  </b-card>
                  <b-card-header v-if="DEVELOPMENT_MODE">global variables</b-card-header>
                  <JsonData :json-string='{"username":username,"password":password}' v-if="DEVELOPMENT_MODE"></JsonData>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>

import { AuthService } from '../../services/auth.service'
import { ANONYMOUS_USER_PASSWORD, HOMEPAGE_URL, DEVELOPMENT_MODE } from '../../env'
import JsonData from '../../components/JsonData'

export default {
  name: 'Login',
  components: { JsonData },
  data () {
    return {
      DEVELOPMENT_MODE: false,
      username: '',
      password: '',
      remember_me: false,
      error: '',
      pp_accept: false
    }
  },
  mounted () {
    this.DEVELOPMENT_MODE = DEVELOPMENT_MODE === 'true'
  },
  methods: {
    submit () {
      if (this.pp_accept.toString() === 'false') {
        this.error = this.$t('Please accept TOS.')
        return false
      }
      AuthService.makeLogin({ username: this.username, password: this.password })
        .then((response) => {
          localStorage.setItem('addin_bg_color', response.data.addin_bg_color)
          localStorage.setItem('cobranding_logo_path', response.data.cobranding_logo_path)
          window.location.reload()
          this.error = ''
        })
        .catch((error) => {
          if (!error) {
            this.error = 'Username or password mismatch'
          } else if (error.message.username) {
            this.error = this.$t('Username:') + ' ' + this.$t(error.message.username)
          } else if (error.message.password) {
            this.error = this.$t('Password:') + ' ' + this.$t(error.message.password)
          } else if (error.message.non_field_errors) {
            this.error = this.$t('Username:') + '/' + this.$t('Password:') + ' ' + this.$t(error.message.non_field_errors)
          } else {
            this.error = error.message
          }
        })
    },
    openRegister () {
      window.open(HOMEPAGE_URL + '/register', '_blank')
    },
    openPWReset () {
      window.open(HOMEPAGE_URL + '/password-reset', '_blank')
    },
    skipLogin () {
      if (this.pp_accept.toString() === 'false') {
        this.error = this.$t('Please accept TOS.')
        return false
      }
      AuthService.makeLogin({ username: 'anonymous', password: ANONYMOUS_USER_PASSWORD })
        .then((response) => {
          window.location.reload()
          // console.log(response)
          this.error = ''
        })
        .catch((error) => {
          if (!error) {
            this.error = 'Username or password mismatch'
          } else if (error.message.username) {
            this.error = this.$t('Username:') + ' ' + this.$t(error.message.username)
          } else if (error.message.password) {
            this.error = this.$t('Password:') + ' ' + this.$t(error.message.password)
          } else if (error.message.non_field_errors) {
            this.error = this.$t('Username:') + '/' + this.$t('Password:') + ' ' + this.$t(error.message.non_field_errors)
          } else {
            this.error = error.message
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
